<div class="tag-selector-wrapper">
  <label *ngIf="label" class="tag-selector-label">{{ label | translate }}</label>

  <div class="tag-selector" [class.tag-selector--open]="isOpen" [class.tag-selector--disabled]="disabled">
    <button
      #triggerButton
      type="button"
      class="tag-select-button"
      (click)="toggleDropdown($event)"
      [disabled]="disabled"
      [attr.aria-disabled]="readonly"
      [class.tag-select-button--readonly]="readonly"
    >
      <span class="tag-select-button-content">
        @if (readonly || selectedTagIds.length === 0) {
          <span class="tag-select-button-text">{{ selectedTagsDisplay }}</span>
        } @else {
          <span class="selected-tags-list">
            @for (id of selectedTagIds; track id) {
              <span class="tag-chip">
                {{ getTagName(id) }}
                <i
                  class="pi pi-times chip-remove"
                  (click)="removeTag(id, $event)"
                  [attr.aria-label]="'Remove tag' | translate"></i>
              </span>
            }
          </span>
        }
      </span>
      <i class="pi" [ngClass]="isOpen ? 'pi-chevron-up' : 'pi-chevron-down'"></i>
    </button>

    <!-- Выпадашка тегов -->
    <!-- Режим редактирования -->
    <div
      #dropdown
      class="tag-dropdown"
      *ngIf="isOpen && !readonly"
      (click)="$event.stopPropagation()"
      [style.top.px]="dropdownTop"
      [style.left.px]="dropdownLeft"
      [style.width.px]="dropdownWidth"
    >
      <div class="tag-search">
        <input
          type="text"
          [(ngModel)]="tagSearchTerm"
          (input)="onTagSearchChange()"
          [placeholder]="placeholder | translate"
          class="tag-search-input"
          autocomplete="off"
        />
        <button
          type="button"
          class="tag-create-btn"
          *ngIf="allowCreate && canShowCreateButton()"
          [pTooltip]="('UPLOAD_IMAGES.MODAL_TAGS_CREATE_TOOLTIP' | translate) || ''"
          tooltipPosition="top"
          (click)="openCreateTagModal($event)"
        >
          {{ 'UPLOAD_IMAGES.MODAL_TAGS_CREATE' | translate }}
        </button>
      </div>

      <div class="tag-list">
        <div
          class="tag-item"
          *ngFor="let option of filteredTagOptions"
          [class.tag-item--selected]="isTagSelected(option.value)"
          (click)="toggleTagSelection(option.value, $event)"
        >
          <i class="pi" [ngClass]="isTagSelected(option.value) ? 'pi-check' : ''"></i>
          <span>{{ option.label }}</span>
        </div>
        <div class="tag-empty" *ngIf="filteredTagOptions.length === 0">
          {{ 'UPLOAD_IMAGES.MODAL_TAGS_EMPTY' | translate }}
        </div>
      </div>
    </div>

    <!-- Режим просмотра -->
    <div
      #dropdown
      class="tag-dropdown tag-dropdown--readonly"
      *ngIf="isOpen && readonly"
      (click)="$event.stopPropagation()"
      [style.top.px]="dropdownTop"
      [style.left.px]="dropdownLeft"
      [style.width.px]="dropdownWidth"
    >
      <div class="tag-list">
        <div
          class="tag-item tag-item--selected tag-item--readonly"
          *ngFor="let tagName of displayTagNames"
        >
          <i class="pi pi-check"></i>
          <span>{{ tagName }}</span>
        </div>
        <div class="tag-empty" *ngIf="displayTagNames.length === 0">
          {{ 'UPLOAD_IMAGES.MODAL_TAGS_EMPTY' | translate }}
        </div>
      </div>
    </div>
  </div>
</div>

<app-tag-modal
  [visible]="isCreateModalOpen"
  (visibleChange)="isCreateModalOpen = $event"
  [mode]="'create'"
  [initialName]="createModalInitialName"
  [existingTags]="existingTags"
  [disableVisibilityControls]="true"
  (saved)="handleTagCreated($event)"
></app-tag-modal>
